module.exports = __webpack_public_path__ + "static/media/AW_HP_EN_1757x1080_Lemonade.74e84ce7.mp4";